<template>
    <div class="carousel-container" v-if="isDesktop">
        <div class="carousel">
            <!-- Previous Button -->
            <button id="prev" v-if="currentIndex > 0" @click="moveCarousel('prev')">
                <!-- SVG for Previous Arrow -->
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.85"
                        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                        fill="#F6F6F6" />
                    <path d="M22.8789 19.0511L16.1041 25.3465L17.1202 26.2905L23.895 19.9951L22.8789 19.0511Z"
                        fill="black" stroke="black" stroke-width="0.5" />
                    <path d="M23.8948 20.0053L17.12 13.71L16.1046 14.6547L22.8787 20.9493L23.8948 20.0053Z" fill="black"
                        stroke="black" stroke-width="0.5" />
                </svg>
            </button>

            <!-- Carousel Images -->
            <div class="carousel-images" ref="carouselImages">
                <div v-for="(image, index) in productImages" :key="image.src" class="carousel-item"
                    :class="{ visible: index >= currentIndex && index < currentIndex + visibleCount }">
                    <img v-if="image.src" :src="image.src" loading="lazy" @click="selectImage(image)"
                        :class="{ active: selectedImage === image }" />
                </div>
            </div>

            <!-- Next Button -->
            <button id="next" v-if="currentIndex + visibleCount < productImages.length" @click="moveCarousel('next')">
                <!-- SVG for Next Arrow -->
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="0.85"
                        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
                        fill="#F6F6F6" />
                    <path d="M22.8789 19.0511L16.1041 25.3465L17.1202 26.2905L23.895 19.9951L22.8789 19.0511Z"
                        fill="black" stroke="black" stroke-width="0.5" />
                    <path d="M23.8948 20.0053L17.12 13.71L16.1046 14.6547L22.8787 20.9493L23.8948 20.0053Z" fill="black"
                        stroke="black" stroke-width="0.5" />
                </svg>
            </button>
        </div>
    </div>
</template>


<script>
import { eventBus } from 'EventBus/';
export default {
    name: 'vch-image-carousel',
    props: {
        images: {
            type: Array,
            required: true,
            validator: (value) => Array.isArray(value) && value.length <= 12,
        },
    },
    data() {
        return {
            currentIndex: 0,
            visibleCount: 4,
            productImages:[],
            selectedImage: this.images[0] || '',
            isDesktop: false
        };
    },
    computed: {
        visibleImages() {
            return this.productImages.slice(this.currentIndex, this.currentIndex + this.visibleCount);
        },
    },
    mounted() {
        if(this.images.length > 0) {
            this.productImages = this.images;
        }
        eventBus.$on('update-product-images', this.updateMedia);
        this.checkDesktopView();
        window.addEventListener('resize', this.checkDesktopView);
    },
    beforeDestroy() {
        eventBus.$off('update-product-images');
    },
    methods: {
        updateMedia(updatedImages) {
            this.productImages = updatedImages;
            this.currentIndex = 0;
            this.selectedImage = this.productImages[0] || '';
        },

        checkDesktopView() {
            this.isDesktop = window.innerWidth >= 1024;
        },

        moveCarousel(direction) {
            const carouselImages = this.$refs.carouselImages;

            const transitionDuration = 500;
            carouselImages.style.transition = `transform ${transitionDuration}ms ease-in-out`;

            if (direction === 'next') {
                if (this.currentIndex + this.visibleCount < this.productImages.length) {
                    this.currentIndex++;
                }
            } else if (direction === 'prev') {
                if (this.currentIndex > 0) {
                    this.currentIndex--;
                }
            }

            const offset = -(this.currentIndex * (carouselImages.children[0].offsetWidth + 20));
            carouselImages.style.transform = `translateX(${offset}px)`;
        },


        selectImage(image) {            
            this.selectedImage = image;
            this.removeSourcesFromPicture();
            const mainImage = document.getElementById('main-image');
            
            if (mainImage) {
                mainImage.src = image.src;
            }         
        },

        removeSourcesFromPicture(pictureSelector = 'picture') {
            const picture = document.querySelector(pictureSelector);
            if (!picture) return;

            const sources = picture.querySelectorAll('source');
            if (sources.length > 0) {
                sources.forEach(source => source.remove());
            }            
        }
    },
};
</script>
